import { render, staticRenderFns } from "./ObrasSociales.vue?vue&type=template&id=03ac1c6c&scoped=true"
import script from "./ObrasSociales.vue?vue&type=script&lang=js"
export * from "./ObrasSociales.vue?vue&type=script&lang=js"
import style0 from "./ObrasSociales.vue?vue&type=style&index=0&id=03ac1c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ac1c6c",
  null
  
)

export default component.exports